export default function QProviderConfig($qProvider: angular.IQProvider) {
    'ngInject';
    // suppress errors when page transitions cause XHR requests to be aborted
    $qProvider.errorOnUnhandledRejections(false);
}
